import Swiper, { Navigation, Pagination, EffectFade, Controller } from 'swiper';
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination, EffectFade, Controller]);

const settings = {
    productsSliderSelector: '[js-slider-partners]',
    realSliderSelector: '[js-slider-real]',
    headerImgSliderSelector: '[js-slider-header-img]',
    headerTextSliderSelector: '[js-slider-header-text]',
    teamSliderSelector: '[js-slider-team]',
    newsSliderSelector: '[js-news-slider]',
}

/*----------------
SLIDER FLEX CONTENT RASSURANCE
--------------- */
let reviewsSlider = new Swiper(settings.productsSliderSelector, {
    slidesPerView: 1,
    spaceBetween: 24,
    centeredSlides: false,
    loop: false,
    navigation: {
        nextEl: '[js-partners-btn-next]',
        prevEl: '[js-partners-btn-prev]',
    },
    pagination: {
        el: '[js-partners-pagination]',
        clickable: true,
    },
    breakpoints: {
        720: {
            slidesPerView: 2,
        },
        960: {
            slidesPerView: 3,
            spaceBetween: 80,
        },
        1280: {
            slidesPerView: 4,
        },
    }
});

/*----------------
SLIDERs DES REALISATIONS
--------------- */
let realSlider = new Swiper(settings.realSliderSelector, {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: false,
    loop: false,
    navigation: {
        nextEl: '[js-real-btn-next]',
        prevEl: '[js-real-btn-prev]',
    },
    breakpoints: {
        720: {
            slidesPerView: 2,
        },
        960: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
    }
});

/*----------------
SLIDERs HEADER PAGE HOME REGIONALE
--------------- */
let headerImgSlider = new Swiper(settings.headerImgSliderSelector, {
    slidesPerView: 1,
    centeredSlides: false,
    loop: false,

    navigation: {
        nextEl: '[js-header-btn-next]',
        prevEl: '[js-header-btn-prev]',
    },
});


let headerTextSlider = new Swiper(settings.headerTextSliderSelector, {
    slidesPerView: 1,
    centeredSlides: false,
    effect: 'fade',
    loop: false,
    autoHeight: true,
});

if (document.querySelector(settings.headerTextSliderSelector)) {
    headerImgSlider.controller.control = headerTextSlider;
    headerTextSlider.controller.control = headerImgSlider;
}




/*----------------
SLIDER EQUIPE PAGE HOME REGIONALE
--------------- */

let teamSlider = new Swiper(settings.teamSliderSelector, {
    slidesPerView: 2,
    spaceBetween: 8,
    loop: false,
    slidesPerGroup: 2,
    pagination: {
        el: '[js-team-pagination]',
        clickable: true,
    },

    breakpoints: {
        720: {
            spaceBetween: 16,
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        960: {
            slidesPerGroup: 2,
            slidesPerColumnFill: 'row',
            spaceBetween: 24,
            slidesPerView: 2,
            slidesPerColumn: 3,
        },
    }
});

/*----------------
TOGGLE CLICK SLIDER ITEMS
--------------- */
let teamMembers = document.querySelectorAll('[js-team-text-toggler]');
let activeMember;
if (teamMembers && window.innerWidth <= 960) {
    teamMembers.forEach((member) => {
        member.addEventListener('click', () => {
            if (activeMember) {
                activeMember.classList.remove('is-active');
            }
            member.classList.toggle('is-active');
            activeMember = member;
        })
    })
}

/*----------------
SLIDER LAST NEWS
--------------- */

let newsSlider = new Swiper(settings.newsSliderSelector, {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: false,
    loop: false,
    breakpoints: {
        960: {
            allowTouchMove: false,
        }
    }
});
if (document.body.clientWidth >= 960) {
    newsSlider.params.spaceBetween = 0;
    newsSlider.params.noSwiping = true;
}
